import type { PaywallOfferType } from "@/react/types/PaywallOffer";

import { absolutePath } from "./../absolutePath";

export interface PaywallOffersIndexQueryParams {
  paywall_coupon_id?: number | string;
  paywall_id?: number | string;
  paywall_offered_id?: number | string;
  paywall_price_id?: number | string;
  type?: PaywallOfferType;
}

export const offers = {
  index: (params: PaywallOffersIndexQueryParams = {}) =>
    absolutePath("paywalls/offers", params),
};
